/**
 * RealtimeContext - Contexto centralizado para estado do realtime
 * Evita múltiplas instâncias de useRealtimeSync e compartilha estado
 */

import { createContext, useContext, ReactNode } from 'react';
import { useRealtimeSync } from '@/hooks/useRealtimeSync';

interface RealtimeState {
  isConnected: boolean;
  lastSync: Date;
  isOnline: boolean;
  reconnectAttempts: number;
}

const RealtimeContext = createContext<RealtimeState | null>(null);

export const RealtimeProvider = ({ children }: { children: ReactNode }) => {
  // Única instância do hook de realtime
  const realtimeState = useRealtimeSync();
  
  return (
    <RealtimeContext.Provider value={realtimeState}>
      {children}
    </RealtimeContext.Provider>
  );
};

/**
 * Hook para consumir o estado do realtime
 * Deve ser usado dentro de RealtimeProvider
 */
export const useRealtimeStatus = (): RealtimeState => {
  const context = useContext(RealtimeContext);
  
  if (!context) {
    // Fallback para quando usado fora do provider (ex: páginas públicas)
    return {
      isConnected: true,
      lastSync: new Date(),
      isOnline: true,
      reconnectAttempts: 0
    };
  }
  
  return context;
};
